var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.4 205.4",
    style: {
      enableBackground: "new 0 0 217.4 205.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#DFE0E3;}\r\n\t.st2{fill:#CECECE;}\r\n\t.st3{fill:#395398;}\r\n\t.st4{fill:url(#SVGID_00000154392110191301004270000016527841046891231127_);}\r\n\t.st5{fill:#32BA46;}\r\n\t.st6{fill:#7BC5F8;}\r\n\t.st7{fill:url(#SVGID_00000029014889204535125780000004430681565680272827_);}\r\n\t.st8{fill:#F6F6F7;}\r\n\t.st9{fill:url(#SVGID_00000173129273735132096520000009656447754846145684_);}\r\n\t.st10{fill:url(#SVGID_00000119819895918090819580000012477625811656022943_);}\r\n\t.st11{fill:url(#SVGID_00000100383932091800733720000013653282676583070096_);}\r\n\t.st12{fill:url(#SVGID_00000063617052707460637840000009387685928577623949_);}\r\n\t.st13{fill:url(#SVGID_00000021100378676529208150000010696842830581321640_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.5435,
    y1: 6.7558,
    x2: 396.0217,
    y2: 280.2776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9ED32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04790916,
    style: {
      stopColor: "#F8E236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    style: {
      stopColor: "#F7C441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    style: {
      stopColor: "#F49354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3784,
    style: {
      stopColor: "#F0506D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4486,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#BD2A96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#6D2AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#322AE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9467,
    style: {
      stopColor: "#0E2AF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002AFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.8,197.5H70.7c-33.8,0-61.3-27.5-61.3-61.3V69.2c0-33.8,27.5-61.3,61.3-61.3h76.1 c33.8,0,61.3,27.5,61.3,61.3v67.1C208,170,180.6,197.5,146.8,197.5z M70.7,21.5C44.4,21.5,23,42.9,23,69.2v67.1 c0,26.3,21.4,47.7,47.7,47.7h76.1c26.3,0,47.6-21.4,47.6-47.7V69.2c0-26.3-21.4-47.7-47.6-47.7H70.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109732432406167487940000008667700385259671428_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.5435,
    y1: 6.7558,
    x2: 396.0218,
    y2: 280.2776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9ED32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04790916,
    style: {
      stopColor: "#F8E236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    style: {
      stopColor: "#F7C441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    style: {
      stopColor: "#F49354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3784,
    style: {
      stopColor: "#F0506D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4486,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#BD2A96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#6D2AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#322AE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9467,
    style: {
      stopColor: "#0E2AF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002AFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109732432406167487940000008667700385259671428_)"
    },
    d: "M108.7,157.2 c-30.1,0-54.5-24.5-54.5-54.5c0-30.1,24.5-54.5,54.5-54.5c30.1,0,54.5,24.5,54.5,54.5C163.3,132.8,138.8,157.2,108.7,157.2z  M108.7,61.8c-22.6,0-40.9,18.4-40.9,40.9c0,22.6,18.4,40.9,40.9,40.9c22.6,0,40.9-18.4,40.9-40.9 C149.6,80.1,131.3,61.8,108.7,61.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132775748719525035810000003209749948089242541_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.0604,
    y1: -55.5108,
    x2: 434.5048,
    y2: 218.011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9ED32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04790916,
    style: {
      stopColor: "#F8E236"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    style: {
      stopColor: "#F7C441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    style: {
      stopColor: "#F49354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3784,
    style: {
      stopColor: "#F0506D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4486,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#BD2A96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#6D2AC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#322AE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9467,
    style: {
      stopColor: "#0E2AF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002AFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132775748719525035810000003209749948089242541_)"
    },
    d: "M173.7,49.9c0,6.2-5.1,11.3-11.3,11.3 c-6.3,0-11.3-5.1-11.3-11.3c0-6.3,5.1-11.3,11.3-11.3C168.7,38.5,173.7,43.6,173.7,49.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.010a503c5299346ee42bb76c1206f5ef.svg";
export { ForwardRef as ReactComponent };